import React, { useState, useEffect } from "react";
import { Route, Switch, HashRouter, Redirect } from "react-router-dom";
import {
  GeneralDefinition,
  InsertParameter,
  RegistrationEnums,
  SearchPattern,
  Permissions,
} from "../../types/ApplicationTypes";
import {
  getUserRole,
  isAuthenticated,
  signIn,
} from "../../services/AuthService/AuthService";
import HeaderLayout from "../HeaderLayout/HeaderLayout";
import ProfileHeaderLayout from "../HeaderLayout/ProfileHeaderLayout";
import FooterLayout from "../FooterLayout/FooterLayout";
import styles from "./DefaultLayout.module.scss";
import "./DefaultLayout.module.scss";
import routes from "../../routes";
import anonymousRoutes from "../../anonymousRoutes";
import { ToastProvider } from "../../context/ToastProvider";
import ToastContainer from "../ToastContainer/ToastContainer";
import { Layout } from "@mtm/components";
import { getPersonSummary } from "../../services";
import {
  AddCCPRoleToUser,
  getPersonUserAccountInfo,
  GetRegistrationStatusDetails,
} from "../../services/RegistrationService";
import * as OauthCodeFlowService from "../../services/AuthService/OauthCodeFlowService";
import { TripDetailsProvider } from "../../context/TripDetailsContext";
import { PaginationProvider } from "../../context/PaginationContext";
import { PlanDetailsProvider } from "../../context/PlanDetailsContext";
import {
  caregiverSummary,
  defaultCaregiverSummary,
} from "../../types/PersonTypes";
import { DefaultAccommodations } from "../../types/ProfileTypes";
import { PaymentDetailsProvider } from "../../context/PaymentDetailsContext";
import { PersonSummaryProvider } from "../../context/PersonSummaryContext";
import { BillingHistoryProvider } from "../../context/BillingHistoryContext";
import { ServiceUserCreationProvider } from "../../context/ServiceUserCreationContext";
import { DashboardProvider } from "../../context/DashboardContext";
import { GroceryProvider } from "../../context/GroceryContext";
type Props = {
  setPageType: any;
};
const DefaultLayout: React.FC<Props> = ({ setPageType }) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const [isAuth, setIsAuth] = useState(false);
  const [userRoles, setUserRoles] = useState<string[]>([]);
  const [CCPRole, setCCPRole] = useState<boolean>(false);
  const [status, setStatus] = useState<string>("");
  const [manageServices, setManageServices] = useState<boolean>(false);
  const [editProfileServices, setEditProfileServices] = useState<boolean>(
    false
  );
  const [apps] = useState<any>([]);
  const oauthCodeFlow = OauthCodeFlowService;
  const [memberAddress, setMemberAddress] = useState<caregiverSummary>(
    defaultCaregiverSummary
  );
  const [wandaRoles, setWandaRoles] = useState<string[]>([]);

  async function handleUpdateUserDetails() {
    if (!memberAddress.homeAddress?.address2) {
      memberAddress.homeAddress.address2 = "";
    }
    if (!memberAddress.mailingAddress?.address2) {
      memberAddress.mailingAddress.address2 = "";
    }

    const data = {
      firstName: memberAddress.firstName,
      lastName: memberAddress.lastName,
      personId: memberAddress.personId,
      personTypeId: RegistrationEnums.PersonTypeId,
      isActive: true,
      sourceSystemID: RegistrationEnums.SourceSystemID,
      createRelation: true,
      keyTypeId: RegistrationEnums.KeyTypeId,
      dateOfBirth: memberAddress.dateOfBirth,
      gender: memberAddress.gender,
      roles: [
        {
          roleName: "CCP",
        },
      ],
      personAttributes: {
        personContact: {
          WandaEmail: memberAddress.wandaEmail,
          WandaEmailAddressAttribute: {
            notificationOn: true,
            communicationTypes: {
              informative: true,
            },
          },
        },
        personInfo: {
          primaryLanguage: memberAddress.primaryLanguage,
        },
        homeAddress: memberAddress.homeAddress,
        mailingAddress: memberAddress.mailingAddress,
      },
      wandaAccommodations: DefaultAccommodations(),
    };
    AddCCPRolesToUserEntered(data);
  }

  async function AddCCPRolesToUserEntered(data: any) {
    const output = await AddCCPRoleToUser(data);
    if (output.data.success === true) {
      sessionStorage.clear();
      window.location.reload();
    }
  }

  function renderPages() {
    if (wandaRoles.length > 0) {
      if (CCPRole && status === "Failed") {
        return <Redirect from="/" to="/Welcome" />;
      } else if (CCPRole && status === "Success") {
        return <Redirect from="/" to="/DashBoard" />;
      }
    }
  }
  useEffect(() => {
    authorize();
  }, []);

  useEffect(() => {
    if (
      !CCPRole &&
      userRoles.length > 0 &&
      [Permissions.ROLE_Member, Permissions.ROLE_PAYEE].some((role) =>
        userRoles.includes(role)
      )
    ) {
      handleUpdateUserDetails();
    }
  }, [CCPRole, userRoles]);

  function toggle() {
    setIsCollapsed(!isCollapsed);
  }

  async function authorize() {
    const isUserAuthenticated = await isAuthenticated();

    if (window.location.href.includes("Registration")) {
      setIsAuth(false);
    } else if (
      !isUserAuthenticated &&
      !window.location.href.includes("Registration")
    ) {
      await signIn();
      setIsAuth(true);
    } else {
      setIsAuth(true);
    }

    if (isUserAuthenticated) {
      const loginRoles: string[] = await getUserRole();
      if (loginRoles.length > 0) {
        setWandaRoles(loginRoles);
      }
      let user = await oauthCodeFlow.getUser();
      const personId =
        Number(sessionStorage.getItem("POST_LOGIN_URL_PATH_KEY")) || undefined;
      const output = await getPersonSummary(personId);
      const memberInfo: caregiverSummary = {
        firstName: output.personInfo?.firstName,
        lastName: output.personInfo?.lastName,
        dateOfBirth: output.personInfo?.dateOfBirth,
        gender: output.personInfo?.gender,
        primaryLanguage: output.personInfo?.primaryLanguage,
        personId: output.personInfo.personID,
        wandaEmail: user.profile.email,
        homeAddress: output.personAddresses.homeAddress,
        mailingAddress: output.personAddresses.mailingAddress,
      };
      setMemberAddress(memberInfo);
      let wandaRoleInfo = await getPersonUserAccountInfo(
        output.personInfo.personID
      );
      const result = await GetRegistrationStatusDetails(
        wandaRoleInfo.userName,
        GeneralDefinition.DefaultPersonId,
        SearchPattern.RegistrationComplete,
        GeneralDefinition.EmptyString
      );
      setStatus(result.data);
      let roleStatus = wandaRoleInfo.roles.filter(
        (x: { roleId: string }) => x.roleId === "CCP"
      );
      if (roleStatus.length === 1 || loginRoles.includes("role:CCP")) {
        setCCPRole(true);
        setUserRoles(loginRoles);
      } else {
        setCCPRole(false);
        setUserRoles(loginRoles);
      }
    }
  }

  function loading() {
    return (
      <div className="animated fadeIn pt-1 text-center">
        {/* <Spinner type="grow" color="secondary" /> */}
      </div>
    );
  }

  function renderHeader() {
    if (window.location.hash.includes("Grocery")) return;
    if (window.location.hash.includes("DashBoard"))
      return <ProfileHeaderLayout />;
    return <HeaderLayout />;
  }

  function renderFooter() {
    if (!window.location.hash.includes("Grocery")) return <FooterLayout />;
  }

  return (
    <>
      {isAuth ? (
        <HashRouter>
          <Layout>
            <Layout className={styles.app}>
              <ToastProvider>
                <PersonSummaryProvider>
                  <DashboardProvider>
                    <PaginationProvider>
                      <TripDetailsProvider>
                        <PlanDetailsProvider>
                          <ServiceUserCreationProvider>
                            <PaymentDetailsProvider>
                              <BillingHistoryProvider>
                                <GroceryProvider>
                                  {renderHeader()}
                                  <React.Suspense fallback={loading()}>
                                    <Switch>
                                      {routes.map((route: any) => {
                                        return route.component ? (
                                          <Route
                                            key={route.name}
                                            path={route.path}
                                            exact={route.exact}
                                            render={(props) => (
                                              <route.component {...props} />
                                            )}
                                          />
                                        ) : null;
                                      })}
                                      {renderPages()}
                                    </Switch>
                                  </React.Suspense>
                                  {renderFooter()}
                                  <ToastContainer />
                                </GroceryProvider>
                              </BillingHistoryProvider>
                            </PaymentDetailsProvider>
                          </ServiceUserCreationProvider>
                        </PlanDetailsProvider>
                      </TripDetailsProvider>
                    </PaginationProvider>
                  </DashboardProvider>
                </PersonSummaryProvider>
              </ToastProvider>
            </Layout>
          </Layout>
        </HashRouter>
      ) : null}
      {!isAuth ? (
        <HashRouter>
          <Layout>
            <Layout className={styles.app}>
              <ToastProvider>
                <HeaderLayout />
                <React.Suspense fallback={loading()}>
                  <Switch>
                    {anonymousRoutes.map((route: any) => {
                      return route.component ? (
                        <Route
                          key={route.name}
                          path={route.path}
                          exact={route.exact}
                          render={(props) => <route.component {...props} />}
                        />
                      ) : null;
                    })}
                  </Switch>
                </React.Suspense>
                <FooterLayout />
                <ToastContainer />
              </ToastProvider>
            </Layout>
          </Layout>
        </HashRouter>
      ) : null}
    </>
  );
};

export default DefaultLayout;
